module.exports = __webpack_public_path__ + "img/glacier_small.02bfd22b.png";